import "./index.scss"
import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'


import apply_icon from '../../assets/images/icons/apply-icon.png'
import Table from 'react-bootstrap/Table'
import pay_icon from '../../assets/images/icons/pay-icon.png'
import add_calender from '../../assets/images/icons/add-calender.png'
import {
    fetchPaymentsReport,
    fetchAllApplications,
    fetchEvents,
    clearApplications
} from '../../actions'
import moment from 'moment'
import {
    FETCH_APPLICATION_STATUS_ID, 
    FETCH_PAYMENTS_LOADING_ID, 
    FETCH_EVENTS_LOADING_ID} from '../../store/loaders'
import LoadingSpinner from "../../components/loadingSpiner";
import ApplicationStatusModel from "../models/applicationStatusModel";
import FirmApplicationStatusModel from "../models/firmApplicationModel";
import PopupModel from "../../components/models/popupModel";
import EmptyState from "../../components/EmptyState";
import empty_state_icon from '../../assets/images/empty-icon.png'
import empty_state_icon2 from '../../assets/images/empty-icon-1.png'
import empty_state_icon3 from '../../assets/images/empty-icon-2.png'





export default function Home(props){
    console.log(JSON.parse(localStorage.getItem('currentUser')));
    const dispatch = useDispatch()
    const history = useHistory()

    const apiResponse = useSelector(state=>{
        const {paymentReport,
            events, 
            userApplications,
            hasUpdatedIndividualApplication, 
            loader,
            membership
        } = state
        const {report} = paymentReport
        const {event} = events
        const {applications} = userApplications
        const {isLoading} = loader[FETCH_APPLICATION_STATUS_ID] || {isLoading: false}
        const paymentLoader = loader[FETCH_PAYMENTS_LOADING_ID]
        const {message} = hasUpdatedIndividualApplication
        const {application} = membership

        return {
            report,
            event,
            applications,
            isLoading,
            paymentLoader,
            message,
            application
        }
    })




   
    var user = JSON.parse(localStorage.getItem('currentUser'))
    var currentUser = JSON.parse(localStorage.getItem('currentUser'))

    const [showApplicationModel, setApplicationModel] = useState(false)
    const [showFirmModel, setFirmModel] = useState(false)
    const [showPopupModel, setPopupModel] = useState(false)
    const [firmData, setFirmData] = useState('')
    const [modelData, setModelData] = useState('')
 



   

    useEffect(()=>{
        if(apiResponse.message === props.location.state?.id){
            dispatch(fetchAllApplications(currentUser.sub))
        }
    },[apiResponse.message])

    useEffect(()=>{
        dispatch(fetchPaymentsReport(currentUser.sub))
        dispatch(fetchEvents(currentUser.sub))
        dispatch(fetchAllApplications(currentUser.sub))
     },[])


     const handleApplicationModel = (data)=>{
       
        if(data?.status?.toLowerCase() === 'not submitted' || data?.status?.toLowerCase().includes('rejected')){
            if(data?.applicantType?.name === 'Firm Application'){
                history.push({
                    pathname: '/applicant/company/review-details',
                    state:{
                        application: data,
                        message:{
                            note: data?.latestComment || data?.note || data?.clientStatus,
                            date: moment(data?.createdAt).format('MMMM Do YYYY, h:mm:ss a'),
                            status:  data?.status
                        } 
                    }
                })
            }
            if(data?.applicantType?.name === 'Individual Application' || data?.applicantType === null){
                history.push({
                    pathname: '/applicant/review-details',
                    state:{
                        application: data,
                        message:{
                            note: data?.latestComment || data?.note || data?.clientStatus,
                            date: moment(data?.createdAt).format('MMMM Do YYYY, h:mm:ss a'),
                            status:  data?.status
                        }
                    }
                })
            }
            return
        }
        if(data && data?.applicantType?.name === 'Firm Application' || data?.itemType === "FIRM APPLICATION"){
            setFirmModel(true)
            setModelData('')
            setFirmData(data)
            return 
        }
        if(data && data?.applicantType?.name === 'Individual Application' || data?.itemType === "INDIVIDUAL APPLICATION"){
            setApplicationModel(true)
            setModelData(data)
            setFirmData('')
            return
        }
        setFirmModel(false)
        setApplicationModel(false)
    }


    var paymentReport
    if(apiResponse.report?.length > 0){
       paymentReport = apiResponse.report
       .slice(0,6)
       .map(value=>{
           return(
               <tr>
               <td>{moment(value.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</td>
               <td >{value.description}</td>
               <td>{value.amount}</td> 
               <td className={value.status}>{value.status}</td>
               <td>
                   <div className="d-flex" onClick={()=>handleApplicationModel(value)}>
                    <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                        backgroundColor : 'white', border : '1px solid #00AE51'}}>
                        <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                            <img style={{alignSelf : 'center'}}
                            src={require('../../assets/images/icons/icon_eye.svg').default}/>
                            <span style={{fontSize : '10px', color : '#00AE51', marginTop : '3px'}}>VIEW PAID ITEM</span>
                        </div>
                    </button>
                   </div>
               </td>
           </tr>
           )
       })
    }


    const handleNewClass = ()=>{
        var itemStatus = []
        itemStatus = apiResponse.applications && apiResponse.applications.filter(el=>{
            return el.status === 'not submitted'
        })
        if(itemStatus?.length > 0){
            setPopupModel(true)
        }
        else{
            history.push('/applicant')
            sessionStorage.setItem('application', true)
        }
        dispatch(clearApplications())
    }


    return (
    <div className="dashboard_wrapper">
        <div className="toolbar">
            <div className="toolbar-title">
                <h2>Dashboard</h2>
            </div>
            {/* <div className="apply-btn">
                <img alt="e-card" src={e_card_icon}/>
                <span>Apply for an E-Card</span>
            </div>
            <div className="apply-btn">
                <img alt="stap" src={stamp_icon}/>
                <span>Apply for a Stamp</span>
            </div> */}
            <div className="apply-btn" onClick={handleNewClass}>
                <img src={apply_icon} alt="file"/>
                <span>{`${apiResponse.application ? 'Upgrade my' : 'Apply for a'} `} membership</span>
            </div>
        </div>

        <div className="header-container">
            <span>
                Welcome <span style={{fontWeight: '900'}}> {`${user.name}`}</span>
            </span>
        </div>

        <div className="tables">
            <div className="table-item">
                <h3 className="mb-4">Applications status</h3>
                {/* <Table selectable={false} data={data} titles = {titles}/> */}
                <Table striped hover responsive>
                    <thead>
                        <tr>
                            <th>Created on</th>
                            <th>
                                <div className="d-flex align-items-center">
                                    Membership
                                </div>
                            </th>
                            <th>
                                Discipline
                            </th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                      {apiResponse.applications?.length > 0 ? 
                        <>
                            {apiResponse.applications.map(value=>{
                                return(
                                    <tr>
                                        <td>{moment(value.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</td>
                                        <td>{value.applicantType?.name}</td>
                                        <td>{value.discipline?.name}</td>
                                        <td className={value.status}>{value.clientStatus || value.status}</td>
                                        <td>
                                            <div className="d-flex">
                                                <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                                                    backgroundColor : 'white', border : '1px solid #00AE51'}} onClick={()=>handleApplicationModel(value)}>
                                                    <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                                        <img style={{alignSelf : 'center'}}
                                                        src={require('../../assets/images/icons/icon_eye.svg').default}/>
                                                        <span style={{fontSize : '10px', color : '#00AE51', marginTop : '3px'}}>VIEW</span>
                                                    </div>
                                                </button>
                                             { value.status === 'Pending payment' && <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                                                    backgroundColor : 'white', border : '1px solid #003D99', marginLeft:5}}
                                                    onClick={()=>history.push({
                                                        pathname: '/applicant/payment-details',
                                                        state: {
                                                            application: value,
                                                            isFirm:  value.applicantType?.name === 'Firm Application' ? true : false
                                                        }
                                                    })}
                                                    >
                                                    <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                                        <img style={{alignSelf : 'center'}}
                                                        src={pay_icon}/>
                                                        <span style={{fontSize : '10px', color : '#003D99', marginTop : '3px'}}>PAY</span>
                                                    </div>
                                                </button>}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </> 
                        : 
                        <React.Fragment>
                            {apiResponse.isLoading ? <tr>
                                <td colSpan={7}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <LoadingSpinner color={'#1D834F'}/>
                                    </div>
                                </td>
                            </tr> : 
                            <tr>
                                <td colSpan={7}>
                                    <EmptyState
                                        header="No applications available yet"
                                        content="Available applications will be displayed here"
                                        img={empty_state_icon2}
                                    />
                                </td>
                            </tr>
                           }
                        </React.Fragment>
                     
                        }
                    </tbody>
                </Table>
            </div>
            <div className="spacer"></div>
            <div className="table-item">
                <h3 className="mb-4">Payments status</h3>
                {/* <Table selectable={false} data={data} titles = {titles}/> */}
                <Table striped hover responsive>
                    <thead>
                        <tr>
                            <th>Done on</th>
                            <th>
                                <div className="d-flex align-items-center">
                                    Description
                                    {/* <img src={carets_icons} alt="carets"/> */}
                                </div>
                            </th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        { apiResponse.paymentLoader?.isLoading ? 
                         <React.Fragment>
                            <tr>
                                <td colSpan={7}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <LoadingSpinner color={'#1D834F'}/>
                                    </div>
                                </td>
                            </tr>
                            
                           
                        </React.Fragment> :
                            paymentReport?.length> 0 ?
                            paymentReport : 
                            <tr>
                                <td colSpan={7}>
                                    <EmptyState
                                        header="No payments available yet"
                                        content="Available payments will be displayed here"
                                        img={empty_state_icon3}
                                    />
                                </td>
                            </tr>
                        }

                    </tbody>
                </Table>
            </div>
        </div>
        <div className="tables mt-4">
            <div className="table-item">
                <h3 className="mb-4">Calendar</h3>
         
                <Table striped hover responsive>
                    <thead>
                        <tr>
                            <th>Event date/time</th>
                            <th>
                                <div className="d-flex align-items-center">
                                    Message/Description
                                </div>
                            </th>
                            <th>Type</th>
                            <th>Location</th>
                            {/* <th>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {apiResponse.event?.length > 0 ?
                        <>
                        {apiResponse.event.map(value=>{
                            return(
                                <tr>
                                <td>{moment(value.eventDate).format('MMMM Do YYYY, h:mm:ss a')}</td>
                                <td>{value.description}</td>
                                <td>{value.type?.name}</td>
                                <td className="table-status-pending">{value.venue}</td>
                                {/* <td>
                                    <div className="d-flex">
                                            <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                                                backgroundColor : 'white', border : '1px solid #00AE51'}}>
                                                <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                                    <img style={{alignSelf : 'center'}}
                                                    src={require('../../assets/images/icons/icon_eye.svg').default}/>
                                                    <span style={{fontSize : '10px', color : '#00AE51', marginTop : '3px'}}>VIEW</span>
                                                </div>
                                            </button>
                                            <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                                                backgroundColor : 'white', border : '1px solid #00B8F2', marginLeft:5}}>
                                                <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                                    <img style={{alignSelf : 'center'}}
                                                    src={add_calender}/>
                                                    <span style={{fontSize : '10px', color : '#00B8F2', marginTop : '3px'}}>ADD TO YOUR CALENDAR</span>
                                                </div>
                                            </button>
                                        </div>
                                </td> */}
                            </tr>
                            )
                        })}
                        </>
                        : 
                        <tr >
                            <td colSpan={4}>
                                <EmptyState
                                    header="No events available yet"
                                    content="Available events will be displayed here"
                                    img={empty_state_icon}
                            />
                            </td>
                        </tr>
                    
                        }
                       
                    </tbody>
                </Table>
            </div>
        </div>
        <ApplicationStatusModel 
            show={showApplicationModel} 
            hide={handleApplicationModel}
            data={modelData}
            />
        <FirmApplicationStatusModel
            show={showFirmModel} 
            hide={handleApplicationModel}
            data={firmData}
        />
        <PopupModel
            show={showPopupModel}
            hide={()=>setPopupModel(!showPopupModel)}
            content="There is still an application which is not submitted yet"
            btnText="OK"
            hideBtn={true}
            />
    </div>
)
}
